import React, { FunctionComponent } from "react";
import Layout from "../components/layout";
import { SkillCategoryData, skills } from "./skills.data";
import { Card, CardContent } from "../components/card";
import { Tag } from "../components/tag";
import { SkewedTextBox } from "../components/SkewedTextBox";

interface SkillCategoryProps {
  category: SkillCategoryData;
}

const SkillCategory: FunctionComponent<SkillCategoryProps> = ({ category }) => {
  return (
    <Card className="h-full">
      <CardContent className="flex justify-center">
        <SkewedTextBox variant="h4" align="center" color="primary">
          {category.title}
        </SkewedTextBox>
      </CardContent>
      <CardContent>
        <div className="flex justify-center flex-wrap gap-2">
          {category.entries.map((entry, i) => (
            <Tag key={i}>{entry}</Tag>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

const SkillsPage = () => {
  return (
    <Layout title="Software Skills">
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2">
        {skills.map((skill) => (
          <SkillCategory key={skill.title} category={skill} />
        ))}
      </div>
    </Layout>
  );
};

export default SkillsPage;
